import { Provider } from '@angular/core';

import { LeadsApiService } from './leads-api.service';
import { LeadsHttpService } from './leads-http.service';

/** Registra la implementación de `LeadsApiService` que usa la app. */
export function provideLeads(): Provider[] {
  return [{ provide: LeadsApiService, useClass: LeadsHttpService }];
}
